import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { EnumFilter, SelectedDepartmentFilter, UserFilter } from 'support/filters'
import BackToOverview from 'widgets/navigation/BackToOverview'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { Link } from '@morningtrain/react-navigation'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import { PaginationFilter } from '@morningtrain/react-filters'
import ContractSmartview from 'pages/app/hr/employments/smartviews/ContractSmartview'
import ContractTemplateFilter from 'support/filters/ContractTemplateFilter'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function Contracts (props) {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='hr.contracts'>
        <UI.PageHeader title={<TranslatedTitle name='titles.contracts' />}>
          <UI.ButtonWrap>
            <BackToOverview route='app.hr.employments'>
              <Translation name='actions.back_to_employments' />
            </BackToOverview>
            <Can permission={Permissions.CONTRACTS_MANAGE}>
              <Link route='app.hr.contract_templates'>
                <UI.Button>
                  <UI.WithIcon size={5} placement='right' icon={<UI.Icons.Settings />}>
                    <Translation name='actions.manage_templates' />
                  </UI.WithIcon>
                </UI.Button>
              </Link>
            </Can>
            <Can permission={Permissions.CONTRACTS_MANAGE}>
              <MountSmartviewOnClick smartview={<ContractSmartview create />} replace={false}>
                <UI.Button color='primary'>
                  <Translation name='generic.create' />
                </UI.Button>
              </MountSmartviewOnClick>
            </Can>
          </UI.ButtonWrap>
        </UI.PageHeader>
      </Translator>
      <Collection resourceName='employments.contracts'>
        <SelectedDepartmentFilter />
        <Can permission={Permissions.CONTRACTS_MANAGE}>
          <MountSmartviewOnSelection smartview={<ContractSmartview create={false} />} replace={false} />
        </Can>

        <UI.Card>
          <UI.TableHeader>
            <ContractTemplateFilter />
            <UserFilter />
            <EnumFilter
              name='focused_status'
              enum='focused_contract_status'
              label='status'
              placeholder='-'
              defaultValue='pending'
            />
          </UI.TableHeader>
          <Table className='cursor-pointer'>
            <Columns.Text
              name='department_name'
              label={<Translation name='columns.department.label' />}
            />
            <Columns.Text
              name='template_name'
              label={<Translation name='columns.contract_template.label' />}
              sortSlug='sortByTemplateName'
            />
            <Columns.Text
              name='user_name'
              label={<Translation name='columns.user.label' />}
            />
            <Columns.Text
              name='employment_type'
              label={<Translation name='columns.employment_type.label' />}
            />
            <Columns.Enum
              name='detailed_status'
              label={'status'}
              enum='detailed_contract_status'
            />
          </Table>
          <PaginationFilter />
        </UI.Card>
      </Collection>
    </AdminPageWithSmartview>
  )
}
